export const brands = [
    'MUTUAL',
    'ALTEUM',
    'DONPAGO',
    'VARO',
    'EZYTRANSFER',
    'COLURS',
    'PAGAHOY',
    'COLOCA',
    'BITPPI',

]